import { render, staticRenderFns } from "./SitesMenu.vue?vue&type=template&id=72ec818a&scoped=true&"
import script from "./SitesMenu.vue?vue&type=script&lang=js&"
export * from "./SitesMenu.vue?vue&type=script&lang=js&"
import style0 from "./SitesMenu.vue?vue&type=style&index=0&id=72ec818a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ec818a",
  null
  
)

export default component.exports